import sendRequest from "../fetch"
import Qs from 'qs'
import { cleanParams, getApi } from "@/utils";


// 获取公共枚举
export const getEnumsList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "sys/common/enum", {
    data: _params,
    method: "POST",
  });
};


// COMMON(1，"公共模块"，"/common")
// BASE(2，"基础模块"，"/base"),
// AVATAR(3,"头像"，"")
// STUDENT_CERT(4,"学生证件""/student/cert")
// TEACHER_CERT(5,"教师证件",，"/teacher/cert");

// 上传地址
export const uplpadUrl = () => {
  return `${getApi()}common/minio/upload`;
}
// 上传地址
export const uplpadOSSUrl = () => {
  return `${getApi()}common/oss/private/upload`;
}



// WEBPACK FOOTER //
// ./src/fetch/api/common.js